import { MenuComponent } from "./component";

export const Menu = MenuComponent;
